export const PROFILE_REQUEST = "PROFILE_REQUEST";
export const PROFILE_SUCCESS = "PROFILE_SUCCESS";
export const PROFILE_FAILURE = "PROFILE_FAILURE";
export const PROFILE_UPDATE_SUCCESS = "PROFILE_UPDATE_SUCCESS";
export const LOGOUT = "USER_LOGOUT";

export const CHECK = "USER_CHECK";
export const CHECK_FAILURE = "CHECK_FAILURE";
